import React, { useEffect, useState, useRef } from "react";
import {
  Modal,
  Button,
  Menu,
  Dropdown,
  Radio,
  Input,
  Space,
  Alert,
  Tooltip,
  Spin,
  Select,
  Col,
  Divider,
  Row,
} from "antd";
import {
  DownOutlined,
  CheckCircleFilled,
  CloseCircleFilled,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { setConfigData } from "../../../redux/actions/ApiCall";
import {
  getShareableBrands,
  getShareTemplateData,
  checkSharableLink,
  setPasswordStatus,
} from "../../../redux/actions/ApiCall/apiCall";
import locobuzzLogo from "../../../assets/Locobuzz_logo.png";
import Login_Image from "../../../assets/Login_Image.svg";
import { LoadingOutlined } from "@ant-design/icons";
import LinkNotFound from "./LinkNotFound";

const style = { background: "#0092ff", padding: "0.8rem 0" };

const PasswordModal = ({ isModalShare, handleChangeShare }) => {
  const dispatch = useDispatch();
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const config = useSelector((state) => state.apiCall.config);

  const sharedDuration = useSelector((state) => state.Share.sharedDuration);
  const shareCategory = useSelector((state) => state.ApiCall.shareCategory);
  const graphLoader = useSelector((state) => state.SmartInsights.graphLoader);
  const shareLoaders = useSelector((state) => state.ApiCall.shareLoaders);

  const shareableLinkStatus = useSelector(
    (state) => state.ApiCall.shareableLinkStatus
  );
  const authParams = useSelector((state) => state.Authentication.authParams);

  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const passwordLoader = useSelector((state) => state.ApiCall.passwordLoader);

  const [password, setPassword] = useState();

  var urlParams; // url encrypted parameters

  //Function to get url params from URL and set it to urlParams variable
  (window.onpopstate = function () {
    var match,
      pl = /\+/g, // Regex for replacing addition symbol with a space
      search = /([^&=]+)=?([^&]*)/g,
      decode = function (s) {
        return decodeURIComponent(s.replace(pl, " "));
      },
      query = window.location.search.substring(1);

    urlParams = {};
    while ((match = search.exec(query)))
      urlParams[decode(match[1])] = decode(match[2]);
  })();

  useEffect(() => {}, [passwordLoader]);

  const handleOk = () => {
    handleChangeShare(false);
  };

  const handleCancel = () => {
    handleChangeShare(false);
  };

  const handleChangePassword = (e) => {
    let text = e.target.value;
    setPassword(text);
  };

  const submitPassword = () => {
    sessionStorage.setItem("shareLinkPassword", password);
    dispatch(
      getShareableBrands(
        urlParams.share_id,
        shareLoaders,
        password,
        graphConditionConfig
      )
    );
  };

  return (
    <>
      {shareTemplateData?.error_code === 501 ||
      shareTemplateData?.error_code === 602 ? (
        <LinkNotFound errorCode={shareTemplateData?.error_code} />
      ) : (
        <div className="share-link-modal">
          <Modal
            visible={isModalShare}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={""}
            width={800}
            maskClosable={false}
            closable={false}
            className={`shareModal ${
              authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
            }`}
          >
            <Row gutter={0}>
              <Col className="gutter-row" span={12}>
                <img src={Login_Image} alt="" />
              </Col>
              <Col className="gutter-row" span={12}>
                <div
                  className="bg__white"
                  style={{
                    padding: "0.5rem 2rem 0",
                    borderRadius: "0 0 0.4rem 0.4rem",
                    height: "100%",
                  }}
                >
                  <div className="border-left" style={{ marginTop: "2rem" }}>
                    <img src={locobuzzLogo} alt="Locobuzz" />
                  </div>
                  <div
                    className="form-group mb-0"
                    style={{ marginTop: "8rem" }}
                  >
                    <br />
                    <label
                      htmlFor="CreatePassword"
                      className="portlet-label d-block"
                    >
                      <b>Protected Link</b>
                    </label>
                    <p>
                      To access this shared dashboard, please enter the password
                    </p>
                    <Input.Password
                      placeholder="Password"
                      style={{ maxWidth: "25rem" }}
                      className="border border-color"
                      onChange={handleChangePassword}
                    />
                  </div>

                  <br />

                  <div>
                    {passwordLoader ? (
                      <Spin
                        indicator={
                          <LoadingOutlined style={{ fontSize: 24 }} spin />
                        }
                      />
                    ) : (
                      <Button
                        type="primary"
                        shape="round"
                        onClick={submitPassword}
                        className="ant-btn-primary_blue"
                        style={{ borderRadius: "2.5rem" }}
                        disabled={
                          passwordLoader ||
                          !password ||
                          (typeof password === "string" &&
                            String(password)?.trim()) === "" ||
                          password?.length < 1
                        }
                      >
                        Submit
                      </Button>
                    )}
                  </div>
                  <br />
                  <br />
                </div>
              </Col>
            </Row>
          </Modal>
        </div>
      )}
    </>
  );
};

export default PasswordModal;
